//全局组件注册
import noData from './noData/noData.vue' //相册管理
import audioIcon from './audioIcon/audioIcon.vue' //相册管理
import chooseLocation from './chooseLocation/chooseLocation.vue' //相册管理

function plugins(Vue){
	Vue.component("no-Data",noData)
	Vue.component("audioIcon",audioIcon)
	Vue.component("chooseLocation",chooseLocation)
}

export default plugins